import { createFileRoute } from '@tanstack/react-router';
import { requireWorkstation } from '../../../../utils/workstationGuard';
import { lazy, Suspense } from 'react';
import Loading from '../../../../pages/Loading/Loading';

const PrintTagsTracking = lazy(() => import('../../../../pages/PrintTagsTracking/PrintTagsTracking'));

export const Route = createFileRoute('/$lang/_authenticated/print-tags-tracking')({
  beforeLoad: requireWorkstation,
  component: () => (
    <Suspense fallback={<Loading />}>
      <PrintTagsTracking />
    </Suspense>
  ),
});
